import { Injectable, EventEmitter } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EmployeeSelectableListModel } from '../../model/employeeSelectableListModel';
import { OfficeSelectableListModel } from '../../model/officeSelectableListModel';
import { SearchEmployeesToManageRequestModel } from '../../model/searchEmployeesToManageRequestModel';
import { SearchEmployeesToManageResponseModel } from '../../model/searchEmployeesToManageResponseModel';
import { GetEmployeesAndOfficesToSelectToManageModel } from '../../model/getEmployeesAndOfficesToSelectToManageModel';
import { UnselectEmployeesToManageRequestModel } from '../../model/unselectEmployeesToManageRequestModel';
import { UnselectEmployeesToManageResponseModel } from '../../model/unselectEmployeesToManageResponseModel';
import { SelectEmployeesToManageRequestModel } from '../../model/selectEmployeesToManageRequestModel';
import { SelectEmployeesToManageResponseModel } from '../../model/selectEmployeesToManageResponseModel';
import { ManageEmployeeListModel } from '../../model/manageEmployeeListModel';
import { WorkflowModel } from '../../model/workflowModel';


@Injectable()
export class TransferEmployerCloseOfficeService {

  private notifyOfficesList : EventEmitter<OfficeSelectableListModel[]> = new EventEmitter<OfficeSelectableListModel[]>();
  private notifyWorkflowModel : EventEmitter<WorkflowModel> = new EventEmitter<WorkflowModel>();
  private notifysearchEmployeesRequestModel : EventEmitter<SearchEmployeesToManageRequestModel> = new EventEmitter<SearchEmployeesToManageRequestModel>();
  private notifySelectEmployeesRequestModel : EventEmitter<SelectEmployeesToManageRequestModel> = new EventEmitter<SelectEmployeesToManageRequestModel>();
  private notifyManageEmployeeList : EventEmitter<Array<ManageEmployeeListModel>> = new EventEmitter<Array<ManageEmployeeListModel>>();
  private notifySearchEmployeesToManageResponseModel : EventEmitter<SearchEmployeesToManageResponseModel> = new EventEmitter<SearchEmployeesToManageResponseModel>();
  private notifyEmployeeSelectableList : EventEmitter<Array<EmployeeSelectableListModel>> = new EventEmitter<Array<EmployeeSelectableListModel>>();
  private notifySelectEmployeesToManageResponseModel : EventEmitter<SelectEmployeesToManageResponseModel> = new EventEmitter<SelectEmployeesToManageResponseModel>();


  constructor(private http : HttpClient) { }

  getSelectableOffices(workflowID: number){
    //GET /api/ManageEmployeesSearchEmployees
    const params = new HttpParams()
    .set('workflowID', workflowID.toString());
      return this.http.get<OfficeSelectableListModel[]>(environment.server_url+"/api/ManageEmployeesSearchEmployees", {params});
  }

  searchEmployeesByCriteria(searchEmployeeRequest: SearchEmployeesToManageRequestModel){
    //POST /api/ManageEmployeesSearchEmployees
    return this.http.post<SearchEmployeesToManageResponseModel>(environment.server_url+"/api/ManageEmployeesSearchEmployees",searchEmployeeRequest);
  }

  getSelectableOfficesAndSelectableEmployees(workflowID: number){
    //GET /api/ManageEmployeesSelectEmployees
    const params = new HttpParams()
    .set('workflowID', workflowID.toString());
      return this.http.get<GetEmployeesAndOfficesToSelectToManageModel>(environment.server_url+"/api/ManageEmployeesSelectEmployees", {params});
  }

  // If EntityID is 0 then the operation is a Sever, else the value represents the selected Office transferring to
  submitListOfEmployment(selectEmployeesRequest:SelectEmployeesToManageRequestModel){
    //POST /api/ManageEmployeesSelectEmployees
    
    return this.http.post<SelectEmployeesToManageResponseModel>(environment.server_url+"/api/ManageEmployeesSelectEmployees",selectEmployeesRequest);
  }

  getUnselectedEmployees(workflowID: number){
    //GET /api/ManageEmployeesUnselectEmployees
    const params = new HttpParams()
    .set('workflowID', workflowID.toString());
      return this.http.get<Array<ManageEmployeeListModel>>(environment.server_url+"/api/ManageEmployeesUnselectEmployees", {params});
  }

  submitEmployeeListToRemove(unselectEmployeesRequest:UnselectEmployeesToManageRequestModel){
      //POST /api/ManageEmployeesUnselectEmployees
      return this.http.post<UnselectEmployeesToManageResponseModel>(environment.server_url+"/api/ManageEmployeesUnselectEmployees",unselectEmployeesRequest);
  }

  getOfficesToClose(workflowID: number){
      //GET /api/ManageEmployeesCloseOffices
      const params = new HttpParams()
      .set('workflowID', workflowID.toString());
        return this.http.get<Array<OfficeSelectableListModel>>(environment.server_url+"/api/ManageEmployeesCloseOffices", {params});
  }
  

  getNotifyOfficesList(){
    return this.notifyOfficesList;
  }

  getNotifyWorkflowModel(){
    return this.notifyWorkflowModel;
  }

  getNotifysearchEmployeesRequestModel(){
    return this.notifysearchEmployeesRequestModel;
  }

  getNotifySelectEmployeesRequestModel(){
    return this.notifySelectEmployeesRequestModel;
  }

  getNotifyManageEmployeeList(){
    return this.notifyManageEmployeeList;
  }

  getNotifySearchEmployeesToManageResponseModel(){
    return this.notifySearchEmployeesToManageResponseModel;
  }

  getNotifyEmployeeSelectableList(){
    return this.notifyEmployeeSelectableList;
  }

  getNotifySelectEmployeesToManageResponseModel(){
    return this.notifySelectEmployeesToManageResponseModel;
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/transfer-employer-close-office.service.ts